import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';

import { initGA, trackingPageGA, eventGA } from './reactGA';

const App = () => {
  useEffect(() => {
    initGA(); // Inicializar google analytics
    trackingPageGA('/'); // funcion para trackear la pagina 
  }, []);

  const googleAnalyticsEvent = () => {
    eventGA('main-button', 'buttonAction');
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <button className="App-button" onClick={googleAnalyticsEvent}>
          Tracked Button
        </button>
      </header>
    </div>
  );
}

export default App;
